import "rxjs/add/operator/map";
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, Content } from 'ionic-angular';
import { FirebaseListObservable } from 'angularfire2';
import { Validators, FormBuilder } from '@angular/forms';
import { QuestionsData } from '../../providers/questions';
import { AuthData } from '../../providers/auth';
import { EventData } from '../../providers/event';
import { Translate } from '../../providers/translate';

@Component({
  selector: 'page-event-questions',
  templateUrl: 'event-questions.html'
})
export class EventQuestionsPage {
  @ViewChild(Content) content: Content;

  obs1: any;
  event: any;
  client: any;
  tokenDiary: any;
  configQuestion: any;
  dataQuestion: any;
  questionForm: any;
  questionListNew: any = [];
  numQuestions: any;
  questionList: FirebaseListObservable<any[]>;
  toastNew: any;
  user: any;
  textTranslate: any;

  /**
   * Questions page
   * @description: Load questions for event and now diary
   *
   * @param navCtrl NavController
   * @param params NavParams
   */
  constructor(public navCtrl: NavController, public params: NavParams, public loading: LoadingController, public toastCtrl: ToastController, private formBuilder: FormBuilder, public questionProvider: QuestionsData, public auth: AuthData, public eventProvider: EventData, translate: Translate) {

    translate.translateGroup(['Existen nuevas preguntas publicadas', 'Actualizar', 'Gracias por el Like', 'Guardando', 'Pregunta publicada correctamente'])
    .then(result => {
      this.textTranslate = result;
    })

    // Load user
    this.user = this.auth.getUser();

    // Load params
    this.event = this.params.get('event');
    this.tokenDiary = this.params.get('diary');
    this.client = this.params.get('client');

    // Init forms
		this.dataQuestion = {
			text: '',
      isAnonymous: this.user.isAnonymous
		};

    this.questionForm = this.formBuilder.group({
      text: ['', Validators.required],
      anonymous: ['']
    });

    // Load config question
    this.questionProvider.getConfigQuestion(this.client, this.event.id, this.tokenDiary)
    .then(data1 => {
      this.configQuestion = data1;

      // if load config question data subscribe
      this.obs1 = this.questionProvider.getListQuestions(this.client, this.event.id, this.tokenDiary, this.configQuestion ? this.configQuestion.allQuestions : true)
      .subscribe((data: any) => {

        if (!this.questionList) {
          this.numQuestions = data.length;

          if (data.length > 0) {
            this.questionList = data.reverse() as FirebaseListObservable<any[]>;

            this.questionList.forEach((question: any) => {
              this.questionProvider.getMyLike(this.client, this.event.id, this.tokenDiary, question.id)
              .then((result: any) => {
                if (result.val()) {
                  question.likeBloqued = 1;
                } else {
                  question.likeBloqued = -1;
                }
              });
            });
          }
        } else {
          this.questionListNew = [];
          // Review each question changes or new question
          data.reverse().forEach((newQuestion: any) => {
            let isNew = true;
            this.questionList.forEach((oldQuestion: any) => {
              if (newQuestion.id == oldQuestion.id) {
                oldQuestion.cssNew = false;
                oldQuestion.text = newQuestion.text;
                oldQuestion.email = newQuestion.email;
                oldQuestion.numLikes = newQuestion.numLikes;
                isNew = false;
              }
            });
            if (isNew) {
              this.questionProvider.getMyLike(this.client, this.event.id, this.tokenDiary, newQuestion.id)
              .then((result: any) => {
                newQuestion.cssNew = true;

                if (result.val()) {
                  newQuestion.likeBloqued = 1;
                } else {
                  newQuestion.likeBloqued = -1;
                }
              });

              if (newQuestion.uid == this.user.uid) {
                let tmp = Object.assign([], this.questionList);
                tmp.unshift(newQuestion);

                this.questionList = tmp as FirebaseListObservable<any[]>;
              } else {
                this.questionListNew.unshift(newQuestion);

                if (!this.toastNew) {
                  this.toastNew = this.toastCtrl.create({
                    message: this.textTranslate["Existen nuevas preguntas publicadas"],
                    showCloseButton: true,
                    closeButtonText: 'Actualizar',
                    dismissOnPageChange: true
                  });

                  this.toastNew.present();

                  this.toastNew.onDidDismiss(() => {
                    let tmp = Object.assign([], this.questionList);
                    this.questionListNew.forEach(newQuestion => {
                      tmp.unshift(newQuestion);
                    });

                    this.numQuestions = data.length;
                    this.questionList = tmp as FirebaseListObservable<any[]>;
                    this.content.scrollToTop();
                    this.toastNew = null;
                  });
                }
              }
            }
          });
        }
      });
    });
  }

  sendLike(question) {
    question.likeBloqued = null;
    this.questionProvider.pushLike(this.client, this.event.id, this.tokenDiary, question.id)
    .then(result => {
      question.likeBloqued = 1;
      // Increase counter dashboard
      this.eventProvider.setTransactionDashboard(this.client, this.event, 'numLikesQuestion');

      let toast = this.toastCtrl.create({
        message: this.textTranslate["Gracias por el Like"],
        duration: 2000,
        dismissOnPageChange: true
      });
      toast.present();
    })
  }

	create() {
		if (this.questionForm.valid) {
      let loader = this.loading.create({
        content: this.textTranslate["Guardando"],
        duration: 5000
      });

      loader.present();

      this.questionProvider.create(this.client, this.dataQuestion, this.event.id, this.tokenDiary)
      .then((data) => {
        this.questionForm.reset();
        this.dataQuestion = {
          text: '',
          isAnonymous: this.user.isAnonymous
        };

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Pregunta publicada correctamente"],
          duration: 5000
        });
        loader.dismiss();
        toast.present();
      })
      .catch(error => {
        let toast = this.toastCtrl.create({
          message: error,
          duration: 5000
        });
        loader.dismiss();
        toast.present();
      });
		}
  }

  // Unsubsucribe observables on exit page
  ionViewWillUnload() {
    console.log('Se eliminan los observable', 'obs1');
    this.obs1.unsubscribe();
  }
}
// TODO: Bug/Warning formBuilder
// TODO: Valid if required loginUser with QuestionConfig
// TODO: Listener questions for QuestionConfig
// TODO: close observable tester loader onCache
// end file



// WEBPACK FOOTER //
// ./src/pages/event-questions/event-questions.ts